import React, {Component} from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import logoSho from '../../themes/icons/sho/logo-sho.svg';
import {connect} from 'react-redux';
import hideOnDevices from '../../utils/hideOnDevices';

const LogoComponent = styled.div`
  cursor: pointer;
  width: ${props => props.theme.logo.width};
  height: ${props => props.theme.logo.height};
  background-image: url(${props => props.theme.logo.backgroundImage});
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
  margin: ${props => props.theme.logo.margin};

  @media (max-width: 480px) {
    width: ${props => props.theme.logo.widthMobile};
    height: ${props => props.theme.logo.heightMobile};
    margin: ${props => props.theme.logo.marginMobile};
  }
`;

const LogoContainer = styled.div`
  ${props => props.theme?.logo?.container};
  ${props => hideOnDevices(props.$hideOn)}
`;

LogoComponent.defaultProps = {
  theme: {
    logo: {
      width: '128px',
      height: '102px',
      backgroundImage: logoSho,
      widthMobile: '73px',
      heightMobile: '58px',
      margin: '0',
      marginMobile: '0'
    }
  }
};

class Logo extends Component {
  static propTypes = {
    url: PropTypes.string,
    hideLogoOn: PropTypes.string
  };

  render() {
    let onClick;
    if (this.props.url) {
      onClick = () => window.open(this.props.url, '_blank');
    }

    return (
      <LogoContainer $hideOn={this.props.hideLogoOn}>
        <LogoComponent onClick={onClick} />
      </LogoContainer>
    );
  }
}

const mapStateToProps = (state) => ({
  hideLogoOn: state.reducer.formContext.hideLogoOn
});

export default connect(mapStateToProps)(Logo);
